import React, { useCallback, useEffect, useRef, useState } from 'react'
import Grid from '@mui/material/Grid2';
import "../catalogs.css";
import { Link, useLocation, useNavigate } from 'react-router-dom';
import { faAngleRight, faChevronLeft, faChevronRight, faXmark } from '@fortawesome/free-solid-svg-icons';
import { FontAwesomeIcon } from '@fortawesome/react-fontawesome';
import 'react-resizable/css/styles.css';
import { Modal, Tab, Tabs } from 'react-bootstrap';
import Select from 'react-select';
import { apiService } from '../../../../services/apiService';
import { toast } from 'react-toastify';
import { faCircleCheck, faEye, faFileLines } from '@fortawesome/free-regular-svg-icons';
import GeneralCaseCats from '../../../../components/catalog/GeneralCaseCats';
import AssignmentsGeneralCase from './BasicTabs/AssignmentsGeneralCase';
// import GeneralCaseDisccuss from './BasicTabs/GeneralCaseDisccuss';
import GeneralCaseKnowledge from './BasicTabs/GeneralCaseKnowledge';
import GeneralCaseHistory from './BasicTabs/GeneralCaseHistory';
import CaseAllDetails from './BasicCaseTabs/CaseAllDetails';
import DiscussTaskCase from './BasicTabs/DiscussTaskCase';


function Triage() {
    const navigate = useNavigate();
    const location = useLocation();
    const [expanded, setExpanded] = useState(true);
    const parts_location = location.pathname.split("/");
    const caseSlug = parts_location[2] || null;
    const taskId = parts_location[3] || null;
    const caseId = parts_location[4] || null;
    const [reloadChild, setReloadChild] = useState(0);
    const [activeTab, setActiveTab] = useState("overview");
    const [activeTabCase, setActiveTabCase] = useState("task");
    const [showCase, setShowCase] = useState(false);
    const [showSuccess, setShowSuccess] = useState(false);
    const handleCloseSuccess = () => setShowSuccess(false);
    const [formData, setFormData] = useState({
        Q0010: '',
        Q0020: '',
        Q0030: '',
        Q0040: '',
        Q0050: '',
        Q0060: '',
        Q0070: '',
        Q0080: '',
        Q0090: '',
        Q0100: '',
    });
    const [errors, setErrors] = useState({});
    const [errorMessage, setErrorMessage] = useState('');
    const [submitloader, setSubmitloader] = useState(false);

    const [reqList, setRequestList] = useState([]);
    const [selectedReqFor, setSelectedReqfor] = useState(null);
    const [selectedReqBy, setSelectedReqBy] = useState(null);
    const [ownerGroupList, setOwnerGroup] = useState([]);
    const [selectedOwnGroup, setSelectedOwnerGroup] = useState(null);
    const [bussEntryList, setBussEntry] = useState([]);
    const [selectedBussEntry, setSelectedBussEntry] = useState(null);
    const [solutionsList, setSolutionList] = useState([]);
    const [selectedSolutions, setSelectedSolutions] = useState(null);
    const [caseTypeList, setCaseTypeList] = useState([]);
    const [selectedCaseType, setSelectedCaseType] = useState(null);
    const [caseSubTypeList, setCaseSubTypeList] = useState([]);
    const [selectedCaseSubType, setSelectedCaseSubType] = useState(null);
    const [ccOthersList, setCcOthersList] = useState([]);
    const [loading, setLoading] = useState(false);
    const [intakeData, setIntakeData] = useState([]);
    const [allData, setAllData] = useState([]);
    const [allDataSubmit, setAllDataSubmit] = useState([]);
    const [refetchData, setRefetchData] = useState(null);
    // const [paginatedata, setPaginateData] = useState({});
    // const [currentPage, setCurrentPage] = useState(1);
    
    const fetchFormData = useCallback(async () => {
        setLoading(true);
        try {
            const response = await apiService.getRequest(`/cases/${caseSlug}/${caseId}`);
            if (response && response.success === true) {
                setAllData(response.data);
                setShowCase(response.data?.can_see_case);
                setAllDataSubmit(response);
                setIntakeData(response.data?.intake_form_data);
                setRefetchData(response.data.form_data);
                setFormData({
                    Q0010: response.data?.form_data?.Q0010?.raw_value || "No",
                    Q0040: response.data?.form_data?.Q0040?.raw_value,
                    Q0050: response.data?.form_data?.Q0050?.raw_value,
                    Q0060: response.data?.form_data?.Q0060?.raw_value || response.data?.intake_form_data?.Q0120?.raw_value,
                    Q0070: response.data?.form_data?.Q0070?.raw_value,
                    Q0080: response.data?.form_data?.Q0080?.raw_value,
                    Q0090: response.data?.form_data?.Q0090?.raw_value,
                    Q0100: response.data?.form_data?.Q0100?.raw_value,
                })
                setFiles(response.data?.form_data?.Q0120?.raw_value || response.data?.intake_form_data?.Q0080?.raw_value || [])
            }else{
                if(response.error === "permission_denied"){
                    toast.error(response.message || "Permission Denied")
                    navigate("/dashboard")
                }
                if(response && response.authenticate === false){
                    await apiService.postRequest('/auth/logout');
                    localStorage.clear();
                    sessionStorage.clear();
                    window.location.href = '/login';
                }
            }
        } catch (error) {
            console.error('Error fetching tab data:', error);
        } finally {
            setLoading(false);
        }
    }, [caseSlug, caseId, navigate]);

    useEffect(() => {
        fetchFormData();
    }, [fetchFormData]);

    

    useEffect(() => {
        
        if (formData?.Q0010 === "Yes") {
            setFormData((prevFormData) => ({
                ...prevFormData,
                Q0020: allData?.form_data?.Q0020?.raw_value || allData?.case?.requested_by_id || "",
                Q0030: allData?.form_data?.Q0030?.raw_value || allData?.case?.requested_for_id || "",
            }));
        } else if (formData?.Q0010 === "No" && allData.is_external !== false) {
            setFormData((prevFormData) => {
                const newData = {
                    ...prevFormData,
                    Q0020: allData?.case?.requested_by_name ?? "",  // Use ?? instead of ||
                    Q0030: allData?.case?.requested_for_name ?? "",
                };
                return newData;
            });
            setSelectedReqBy(null);
            setSelectedReqfor(null);
        }else{
            setFormData((prevFormData) => ({
                ...prevFormData,
                Q0020: allData?.form_data?.Q0020?.raw_value || allData?.case?.requested_by_id || "",
                Q0030: allData?.form_data?.Q0030?.raw_value || allData?.case?.requested_for_id || "",
            }));
        }
    }, [formData?.Q0010, allData]);
    // console.log("Formdata",formData)

    useEffect(() => {
        if (!formData) return;
        // Req By
        if (formData?.Q0020 && reqList.length > 0) {
            const selected = reqList.find(x => x.value === Number(formData?.Q0020));
            selected && setSelectedReqBy(selected);
        }

        // Req For
        if (formData?.Q0030 && reqList.length > 0) {
            const selected = reqList.find(x => x.value === Number(formData?.Q0030));
            selected && setSelectedReqfor(selected);
        }

        // Owner Group
        if (formData.Q0060 && ownerGroupList.length > 0) {
            const selected = ownerGroupList.find(x => x.value === Number(formData.Q0060));
            selected && setSelectedOwnerGroup(selected);
        }

        // Business Entry
        if (formData.Q0070 && bussEntryList.length > 0) {
            const selected = bussEntryList.find(x => x.value === Number(formData.Q0070));
            selected && setSelectedBussEntry(selected);
        }

        // Business Entry
        if (formData.Q0070?.raw_value && bussEntryList.length > 0) {
            const selected = bussEntryList.find(x => x.value === Number(formData.Q0070));
            selected && setSelectedBussEntry(selected);
        }

        // Solutions Entry
        if (formData.Q0080 && solutionsList.length > 0) {
            const selected = solutionsList.find(x => x.value === Number(formData.Q0080));
            selected && setSelectedSolutions(selected);
        }

        // Case Entry
        if (formData.Q0090 && caseTypeList.length > 0) {
            const selected = caseTypeList.find(x => x.value === Number(formData.Q0090));
            selected && setSelectedCaseType(selected);
        }

        if (formData.Q0100 && caseSubTypeList.length > 0) {
            const selected = caseSubTypeList.find(x => x.value === Number(formData.Q0100));
            selected && setSelectedCaseSubType(selected);
        }


    }, [formData,ccOthersList, reqList, ownerGroupList, bussEntryList, solutionsList, caseTypeList, caseSubTypeList]);
    
    useEffect(() => {
        if(allData?.status_string && allData.status_string !== "completed"){
            const fetchData = async () => {
                const response = await apiService.postRequest(`internal-users`);
                if (response.success) {
                    const options = response.data.map((role) => ({
                        value: role.id,
                        label: role.full_name,
                    }));
                    setRequestList(options);
                }
            };
            fetchData();
        }
    }, [allData]);
    useEffect(() => {
        if(allData?.status_string && allData.status_string !== "completed"){
            const fetchData = async () => {
                const response = await apiService.postRequest(`ownership-groups`);
                if (response.success) {
                    const options = response.data.map((role) => ({
                        value: role.id,
                        label: role.name,
                    }));
                    setOwnerGroup(options);
                }
            };
            fetchData();
        }
    }, [allData]);
    useEffect(() => {
        if(allData?.status_string && allData.status_string !== "completed"){
            const fetchData = async () => {
                const response = await apiService.postRequest(`case_holdings`);
                if (response.success) {
                    const options = response.data.map((role) => ({
                        value: role.id,
                        label: role.name,
                    }));
                    setBussEntry(options);
                }
            };
            fetchData();
        }
    }, [allData]);
    useEffect(() => {
        if(allData?.status_string && allData.status_string !== "completed" && selectedOwnGroup?.value ){
            const param = {
                ownership_group_id : selectedOwnGroup?.value
            }
            const fetchData = async () => {
                const response = await apiService.postRequest(`general-case-stage-solutions/list`, param);
                if (response.success) {
                    const options = response.data.map((role) => ({
                        value: role.id,
                        label: role.name,
                    }));
                    setSolutionList(options);
                }
            };
            fetchData();
        }
    }, [allData, selectedOwnGroup]);
    useEffect(() => {
        if(selectedSolutions && allData?.status_string && allData.status_string !== "completed" && selectedSolutions?.value  && selectedOwnGroup?.value){
            const param = {
                ownership_group_id : selectedOwnGroup?.value
            }
            const fetchData = async () => {
                const response = await apiService.postRequest(`case-types/list/${selectedSolutions && selectedSolutions.value}`, param);
                if (response.success) {
                    const options = response.data.map((role) => ({
                        value: role.id,
                        label: role.name,
                    }));
                    setCaseTypeList(options);
                }
            };
            fetchData();
        }
    }, [selectedSolutions,selectedOwnGroup, allData]);
    useEffect(() => {
        if(selectedCaseType && allData?.status_string && allData.status_string !== "completed" && selectedCaseType?.value){
            const fetchData = async () => {
                const response = await apiService.postRequest(`case-sub-types/list/${selectedCaseType && selectedCaseType.value}`);
                if (response.success) {
                    const options = response.data.map((role) => ({
                        value: role.id,
                        label: role.name,
                    }));
                    setCaseSubTypeList(options);
                }
            };
            fetchData();
        }
    }, [selectedCaseType, allData]);
    useEffect(() => {
        if(allData?.status_string && allData.status_string !== "completed"){
            const params = {
                'task_id' : Number(taskId)
            }
            const fetchData = async () => {
                const response = await apiService.postRequest(`cc-users`, params);
                if (response.success) {
                    const options = response.data.map((role) => ({
                        value: role.id,
                        label: role.email,
                    }));
                    setCcOthersList(options);
                }
            };
            fetchData();
        }
    }, [allData,taskId]);
    

    const [filteredSuggestions, setFilteredSuggestions] = useState([]);
    const [activeIndex, setActiveIndex] = useState(-1);
    const [showSuggestions, setShowSuggestions] = useState(false);

    const fetchSuggestions = async (query) => {
        if (!query) {
            return;
        }
    
        try {
            const response = await apiService.postRequest("locations/suggestions", { "search": query , "type" : "case_management" });
            if(response && response.success){
            setFilteredSuggestions(response.data || [])
            //   setSuggestions(response.tags || []); // Adjust based on API response
            }else{
                if(response && response.authenticate === false){
                    await apiService.postRequest('/auth/logout');
                    localStorage.clear();
                    sessionStorage.clear();
                    window.location.href = '/login';
                }
            }
        } catch (error) {
            console.error("Error fetching suggestions:", error);
        }
    };
    const handleInputSuggChange = (e) => {
        const value = e.target.value;
        setFormData({ ...formData, Q0050: value });
        if (value) {
            fetchSuggestions(value);
            setShowSuggestions(true);
        } else {
            setShowSuggestions(false);
        }
    };

    const handleSuggestionClick = (suggestion) => {
        setFormData({ ...formData, Q0050: suggestion });
        setShowSuggestions(false);
    };
    const handleKeyDown = (e) => {
        if (e.key === "ArrowDown" && activeIndex < filteredSuggestions.length - 1) {
            setActiveIndex(activeIndex + 1);
        } else if (e.key === "ArrowUp" && activeIndex > 0) {
            setActiveIndex(activeIndex - 1);
        } else if (e.key === "Enter") {
            if (activeIndex >= 0) {
                const selected = filteredSuggestions[activeIndex];
                setFormData({ ...formData, Q0050: selected.label });
                // setLocationQuery(e.target.value)
                setShowSuggestions(false);
            }
        }
    };

    const handleInputChange = (e) => {
        const { name, value } = e.target;
    
        // Clear the error for the specific field being modified
        setErrors((prevErrors) => ({
            ...prevErrors,
            [name]: '',
        }));
        setFormData({ ...formData, [name]: value });
    };

    useEffect(() => {
        if (formData.Q0010 !== "Yes" && formData.Q0020 === selectedReqBy?.value) {
            setFormData(prev => ({ ...prev, Q0020: allData?.case?.requested_by_name }));
        } else if (formData.Q0010 === "Yes" && selectedReqBy?.value) {
            setFormData(prev => ({ ...prev, Q0020: selectedReqBy?.value }));
        }
    }, [allData?.case?.requested_by_name, formData.Q0010,formData.Q0020, selectedReqBy?.value]);
    
    const [files, setFiles] = useState([]);
    const fileInputRef = useRef(null);
    const MAX_FILES = 20;
    const MAX_TOTAL_SIZE_MB = 200;
    const MAX_FILE_SIZE_MB = 10;
    const MAX_VIDEO_SIZE_MB = 200; // Special limit for video files
    const allowedTypes = [
        'image/jpeg', 'image/png', 'image/gif',
        'image/bmp',                                                    // .bmp
        'application/pdf',
        'text/csv',
        'text/plain',
        'text/html',                                                    // .html
        'application/msword',
        'application/vnd.openxmlformats-officedocument.wordprocessingml.document',
        'application/vnd.ms-excel',                                     // .xls
        'application/vnd.openxmlformats-officedocument.spreadsheetml.sheet', // .xlsx
        'application/vnd.ms-powerpoint',                                // .ppt
        'application/vnd.openxmlformats-officedocument.presentationml.presentation', // .pptx
        'application/zip',                                              // .zip
        'application/x-zip-compressed',                                 // .zip (alternate MIME)
        'multipart/x-zip',                                              // .zip (alternate MIME)
        'message/rfc822',                                               // .mht (alternate MIME)
        'multipart/related',                                            // .mht
        'video/mp4',
        'video/webm',
        'video/ogg',
        'audio/mpeg',                                                   // .mp3
        'audio/mp3',                                                    // .mp3 (alternate MIME)
        'audio/wav',                                                    // .wav
        'audio/wave',                                                   // .wav (alternate MIME)
        'audio/x-wav',                                                  // .wav (alternate MIME)
    ];

    const videoTypes = ['video/mp4', 'video/webm', 'video/ogg'];

    const handleFileChange = (event) => {
        const selectedFiles = Array.from(event.target.files);

        // Check if total number of files exceeds limit
        if (files.length + selectedFiles.length > MAX_FILES) {
            setErrors((prevErrors) => ({
                ...prevErrors,
                Q0120: `You can only upload up to ${MAX_FILES} files.`,
            }));
            return;
        }

        // Check each file size and type
        for (const file of selectedFiles) {
            // Check if it's a video file
            const isVideo = videoTypes.includes(file.type);
            const maxSize = isVideo ? MAX_VIDEO_SIZE_MB : MAX_FILE_SIZE_MB;
            
            if (file.size > maxSize * 1024 * 1024) {
                setErrors((prevErrors) => ({
                    ...prevErrors,
                    Q0120: isVideo 
                        ? `Video files must be less than ${MAX_VIDEO_SIZE_MB} MB.`
                        : `Each file must be less than ${MAX_FILE_SIZE_MB} MB.`,
                }));
                return;
            }
            
            if (!allowedTypes.includes(file.type)) {
                setErrors((prevErrors) => ({
                    ...prevErrors,
                    Q0120: `Only image files (JPEG, PNG, GIF, BMP), CSV, PDF, XLS, XLSX, PPT, PPTX, MP4, WEBM, OGG, MP3, WAV, TXT, DOC, DOCX, HTML, MHT and ZIP are allowed.`,
                }));
                return;
            }
        }

        // Check total combined size of all files (skip if any video file is present)
        const hasVideo = selectedFiles.some(file => videoTypes.includes(file.type)) || 
                        files.some(file => file.file && videoTypes.includes(file.file.type));
        
        if (!hasVideo) {
            const currentSize = files.reduce((acc, file) => acc + file.file?.size, 0);
            const newSize = selectedFiles.reduce((acc, file) => acc + file?.size, 0);
            if (currentSize + newSize > MAX_TOTAL_SIZE_MB * 1024 * 1024) {
                setErrors((prevErrors) => ({
                    ...prevErrors,
                    Q0120: `Total file size cannot exceed ${MAX_TOTAL_SIZE_MB} MB.`,
                }));
                return;
            }
        }
        
        setErrors((prevErrors) => ({
            ...prevErrors,
            Q0120: "",
        }));
        
        const updatedFiles = selectedFiles.map((file) => ({
            file,
            name: file.name,
        }));
        setFiles((prevFiles) => [...prevFiles, ...updatedFiles]);
        fileInputRef.current.value = null;
    };

    const handleDrop = (event) => {
        event.preventDefault();
        const droppedFiles = Array.from(event.dataTransfer.files);

        // Check if total number of files exceeds limit
        if (files.length + droppedFiles.length > MAX_FILES) {
            setErrors((prevErrors) => ({
                ...prevErrors,
                Q0120: `You can only upload up to ${MAX_FILES} files.`,
            }));
            return;
        }

        // Check each file size and type
        for (const file of droppedFiles) {
            // Check if it's a video file
            const isVideo = videoTypes.includes(file.type);
            const maxSize = isVideo ? MAX_VIDEO_SIZE_MB : MAX_FILE_SIZE_MB;
            
            if (file.size > maxSize * 1024 * 1024) {
                setErrors((prevErrors) => ({
                    ...prevErrors,
                    Q0120: isVideo 
                        ? `Video files must be less than ${MAX_VIDEO_SIZE_MB} MB.`
                        : `Each file must be less than ${MAX_FILE_SIZE_MB} MB.`,
                }));
                return;
            }
            
            if (!allowedTypes.includes(file.type)) {
                setErrors((prevErrors) => ({
                    ...prevErrors,
                    Q0120: `Only image files (JPEG, PNG, GIF, BMP), CSV, PDF, XLS, XLSX, PPT, PPTX, MP4, WEBM, OGG, MP3, WAV, TXT, DOC, DOCX, HTML, MHT and ZIP are allowed.`,
                }));
                return;
            }
        }

        // Check total combined size of all files (skip if any video file is present)
        const hasVideo = droppedFiles.some(file => videoTypes.includes(file.type)) || 
                        files.some(file => file.file && videoTypes.includes(file.file.type));
        
        if (!hasVideo) {
            const currentSize = files.reduce((acc, file) => acc + file.file.size, 0);
            const newSize = droppedFiles.reduce((acc, file) => acc + file.size, 0);
            if (currentSize + newSize > MAX_TOTAL_SIZE_MB * 1024 * 1024) {
                setErrors((prevErrors) => ({
                    ...prevErrors,
                    Q0120: `Total file size cannot exceed ${MAX_TOTAL_SIZE_MB} MB.`,
                }));
                return;
            }
        }

        setErrors((prevErrors) => ({
            ...prevErrors,
            Q0120: "",
        }));
        
        const updatedFiles = droppedFiles.map((file) => ({
            file,
            name: file.name,
        }));
        setFiles((prevFiles) => [...prevFiles, ...updatedFiles]);
    };

    const [deletedFiles, setDeletedFiles] = useState([]);

    const handleRemoveFile = (index) => {
        const fileToRemove = files[index];
        
        // Check if this is an existing file (string) rather than a newly uploaded file (object with 'file' property)
        if (typeof fileToRemove === 'string' || (fileToRemove && !fileToRemove.file)) {
            // This is an existing file from the server, track it for deletion
            const fileName = typeof fileToRemove === 'string' ? fileToRemove : fileToRemove.name;
            setDeletedFiles(prev => [...prev, fileName]);
        }
        
        setFiles((prevFiles) => prevFiles.filter((_, i) => i !== index));
        // Reset the file input to allow the same file to be uploaded again
        if (fileInputRef.current) {
            fileInputRef.current.value = null;
        }
    };

    const handleDragOver = (event) => {
        event.preventDefault();
    };
    const validateForm = () => {
        const newErrors = {};
        if(allData && allData.is_external === true){
            if (!formData.Q0010) newErrors.Q0010 = "Requester a BenchTrack user is required.";
        }
        if(formData.Q0010 === "Yes"){
            if (!selectedReqBy) newErrors.Q0020 = "Requested By is required.";
        }else{
            if (!formData.Q0020) newErrors.Q0030 = "Requested By is required.";
        }
        if (!formData.Q0030) newErrors.Q0030 = "Requested For is required.";
        if (!formData.Q0040) newErrors.Q0040 = "Impact is required.";
        if (formData.Q0050 && formData.Q0050.length < 3) {
            newErrors.Q0050 = "Location must be at least 3 characters long.";
        }else if (formData.Q0050 && formData.Q0050.length > 200) {
            newErrors.Q0050 = 'Location be less than 200 characters long.';
        }
        if (!formData.Q0060) newErrors.Q0060 = "Ownership Group is required.";
        if (!formData.Q0070) newErrors.Q0070 = "Business Entity is required.";
        if (!formData.Q0080) newErrors.Q0080 = "Solution is required.";
        if (!formData.Q0090) newErrors.Q0090 = "Case Type is required.";
        if (!formData.Q0100) newErrors.Q0100 = "Case Sub Type is required.";
        // if (!formData.Q0105) newErrors.Q0105 = "Re-assignment Count is required.";
        
        // if (!formData.Q0070) newErrors.Q0070 = "Contact phone is required.";
        
        setErrors(newErrors);
        return Object.keys(newErrors).length === 0;
    };
    const handleSubmit = async (e) => {
        e.preventDefault();
        if (!validateForm()) {
            setErrorMessage('Please fix the errors before proceeding.');
            return;
        }
        setSubmitloader(true);
        try {
            const formDataToSend = new FormData();

            // Filter and add file attachments - only add valid file objects
            if (files && files.length > 0) {
                files
                    .filter((file) => {
                        // Keep only items that are objects with a valid file property
                        return file && 
                            file.file && 
                            typeof file.file !== 'string' && 
                            file.file !== null && 
                            file.file !== undefined;
                    })
                    .forEach((file) => {
                        formDataToSend.append('Q0120[]', file.file);
                    });
            }
            if (deletedFiles && deletedFiles.length > 0) {
                deletedFiles.forEach((fileName) => {
                    formDataToSend.append('deleted_files[]', fileName);
                });
            }
            // Add other form fields
            for (const key in formData) {
                if (formData[key] !== undefined && formData[key] !== null && formData[key] !== '') {
                    formDataToSend.append(key, formData[key]);
                }
            }
             if(allData && allData.is_external !== true){
                formDataToSend.delete('Q0020');
            }
            const response = await apiService.postRequest(`cases/${caseSlug}/${caseId}/submit`, formDataToSend);

            // Check if the response indicates success
            if (response && response.success === true) {
                setShowSuccess(true);
                setErrors({});
                setErrorMessage('');
                fetchFormData();
                setReloadChild(prev => prev + 1);
                toast(response.message || "Submitted Successfully !")
            } else {
                setErrorMessage(response.message || "Failed. Please try again");
                if (response.errors) {
                    setErrors(response.errors);
                }
            }
        } catch (error) {
            console.log("err",error);
        }finally {
            setSubmitloader(false); // Stop loader
        }
    };

    // const [address, setAddress] = useState("");

    // const handleSelect = async (value) => {
    //     const results = await geocodeByAddress(value);
    //     const latLng = await getLatLng(results[0]);
    //     console.log(value, latLng);
    //     setAddress(value);
    // };
    const isLink = (file) => {
        const value = typeof file === "string" ? file : file?.name;
        return /^https?:\/\//i.test(value);
    };
    const sanitizeAndDisplayHTML = (html) => {
        if (!html) return '';

        // Convert line breaks to <br>
        const formattedHTML = html.replace(/\r\n|\r|\n/g, '<br />');

        return formattedHTML;
    };
  return (
    <div className='container-fluid px-0'>
        <div className="resizable-container d-flex">
            <GeneralCaseCats onReload={reloadChild}/>
            <div className='content_container_validate' style={{ flexGrow: 1 }}>
                <Grid size={{md:8,xs:12}} container flexDirection="column" className="jobseekerhead mb-3">
                    <span><b onClick={()=>navigate("/dashboard")}>Dashboard</b> 
                        <FontAwesomeIcon className='angleright' icon={faAngleRight} /> 
                        <b className="formatid_copyclip fw-bold text-decoration-none" style={{color:"#1A5298", width:"max-content"}}
                            onClick={async () => {
                                const url = `${window.location.origin}${allData?.case?.case_task_link}`;
                                const title = allData?.case?.gcase_summary?.short_description || "Case";
                                const textPlain = `${allData?.case?.case_formatted_id}: ${title}\n${url}`;
                                const textHtml = `<a href="${url}" target="_blank">${allData.case?.case_formatted_id}: ${title}</a>`;
                                try {
                                await navigator.clipboard.write([
                                    new ClipboardItem({
                                    "text/html": new Blob([textHtml], { type: "text/html" }),
                                    "text/plain": new Blob([textPlain], { type: "text/plain" }),
                                    }),
                                ]);
                                toast("Link copied to clipboard");
                                } catch (err) {
                                console.error("Failed to copy: ", err);
                                toast("Failed to copy link");
                                }
                            }}
                            >
                            {allData?.case?.case_formatted_id}
                        </b>
                        <FontAwesomeIcon className='angleright' icon={faAngleRight} />
                        <b className="formatid_copyclip fw-bold text-decoration-none" style={{color:"#1A5298", width:"max-content"}}
                            onClick={async () => {
                                const url = `${window.location.origin}${allData?.case?.case_task_link}`;
                                const title = allData?.case?.gcase_summary?.short_description || "Case";
                                const textPlain = `${allData?.task?.task_format_id} - ${allData?.case?.case_formatted_id}: ${title}\n${url}`;
                                const textHtml = `<a href="${url}" target="_blank">${allData?.task?.task_format_id} - ${allData.case?.case_formatted_id}: ${title}</a>`;
                                try {
                                await navigator.clipboard.write([
                                    new ClipboardItem({
                                    "text/html": new Blob([textHtml], { type: "text/html" }),
                                    "text/plain": new Blob([textPlain], { type: "text/plain" }),
                                    }),
                                ]);
                                toast("Link copied to clipboard");
                                } catch (err) {
                                console.error("Failed to copy: ", err);
                                toast("Failed to copy link");
                                }
                            }}
                            >
                            {allData?.task?.task_format_id}
                        </b>
                        </span>
                </Grid>
                <Grid size={{sm:12}} container className="main_jobseeker tab_controllers">
                    {loading ? 
                        <div className='d-flex justify-content-center w-100'>
                            <img style={{ width: "100px" }} src={require('../../../../assets/pinkloader.gif')} alt='Loading...' />
                        </div> :
                        <Grid size={{sm:12}} container justifyContent="space-between">
                            <Grid size={{ lg: expanded ? 7.4 : 11.5, md: expanded ? 7 : 11, xs: 12 }} sx={{ transition: "all 0.35s cubic-bezier(0.4,0,0.2,1)" }} container alignContent="flex-start">
                                <Tabs
                                    activeKey={activeTabCase}
                                    onSelect={(key) => setActiveTabCase(key)}
                                    defaultActiveKey="task"
                                    id="uncontrolled-tab-example" className="mb-4 drafttabs_tabs"
                                >
                                    <Tab eventKey="task" title="Task">
                                        <Grid size={{xs:12}} container justifyContent="space-between" className="jobseekerhead border_botomer mario_fixers">
                                            <Grid container flexDirection="column">
                                                <h3>Helpdesk Review<small className='small_headingstatuses'>{allData?.task?.status}</small></h3>
                                                <span>General Case</span>
                                            </Grid>
                                        </Grid>
                                        <Grid size={{sm:12}} container justifyContent="space-between" alignContent="flex-start">
                                            <Grid size={{xs:12}} container flexDirection="column" justifyContent="center" className={`tab_controllers ${ expanded && "control_splits"}`}>
                                                <Tabs
                                                    activeKey={activeTab}
                                                    onSelect={(key) => setActiveTab(key)}
                                                    defaultActiveKey="overview"
                                                    id="uncontrolled-tab-example" className="drafttabs_tabs mt-4"
                                                    >
                                                    <Tab eventKey="overview" title="Overview" className={`${ expanded && "expanded-grid"}`}>
                                                        <Grid size={{lg:12,xs:12}} container justifyContent="space-between" className="regiter_inputs i94validateinput pt-3">
                                                            <Grid size={{xs:12}} container flexDirection="column">
                                                                <span>Full Name</span>
                                                                <p>{allData?.case?.requested_by_name || "No Data"}</p>
                                                            </Grid>
                                                            <Grid size={{sm:12, xs:12}} container flexDirection="column">
                                                                <span>Short Description</span>
                                                                <p>{intakeData.Q0020?.raw_value}</p>
                                                            </Grid>
                                                            <Grid size={{sm:12, xs:12}} container flexDirection="column">
                                                                <span>Description</span>
                                                                <p className='w-100' dangerouslySetInnerHTML={{ __html: sanitizeAndDisplayHTML(intakeData.Q0030?.raw_value) }} />
                                                            </Grid>
                                                            <Grid size={{md:5.5,sm:5.8, xs:12}} container flexDirection="column">
                                                                <span>Contact Email</span>
                                                                <p>{allData?.case?.requester_email || "No Data"}</p>
                                                            </Grid>
                                                            <Grid size={{md:5.5,sm:5.8, xs:12}} container flexDirection="column">
                                                                <span>Contact Phone</span>
                                                                <p>{allData?.case?.requester_phone || "No Data"}</p>
                                                            </Grid>
                                                        </Grid>
                                                        {allData?.status_string && allData.status_string !== "completed" ?
                                                        <Grid size={{sm:12}} container alignItems="center">
                                                            <div className='w-100 pt-4' >
                                                                <Grid size={{lg:12,xs:12}} container justifyContent="space-between" className="regiter_inputs i94validateinput">
                                                                    {allData && allData.is_external === true ? <>
                                                                    <Grid size={{xs:12}} container flexDirection="column">
                                                                        <span>Is the requester a BenchTrack user?<span style={{color:"Red"}}> *</span></span>
                                                                        <div className='d-flex align-items-center main_radioregister'>
                                                                            <input
                                                                                className='ms-0'
                                                                                // disabled={!showSubmits}
                                                                                type="radio" 
                                                                                name="Q0010"
                                                                                value="Yes"
                                                                                checked={formData.Q0010  === "Yes"} 
                                                                                onChange={handleInputChange} 
                                                                            />Yes
                                                                            <input
                                                                                className='ms-4'
                                                                                // disabled={!showSubmits}
                                                                                type="radio" 
                                                                                name="Q0010"
                                                                                value="No"
                                                                                checked={formData.Q0010  === "No"} 
                                                                                onChange={handleInputChange} 
                                                                            />No
                                                                        </div>
                                                                        {errors.Q0010 && <p style={{color:"Red"}}>{errors.Q0010}</p>}
                                                                    </Grid>
                                                                    {formData.Q0010 !== "Yes" ? 
                                                                        <Grid size={{md:5.5,sm:5.8, xs:12}} container flexDirection="column">
                                                                            <span>Requested by<small className='red_starimpo'>*</small></span>
                                                                            <input value={formData.Q0020 || ""} name='Q0020' onChange={handleInputChange}
                                                                                type="text"
                                                                                maxLength="201"
                                                                            />
                                                                            {errors.Q0020 && <p style={{color:"Red"}}>{errors.Q0020}</p>}
                                                                        </Grid>
                                                                    :
                                                                    <Grid size={{md:5.5,sm:5.8, xs:12}} container flexDirection="column">
                                                                        <span>Requested By<small className='red_starimpo'>*</small></span>
                                                                        <Select
                                                                            isDisabled={formData.Q0010 !== "Yes"}
                                                                            className="basic-single select_withsearch"
                                                                            classNamePrefix="select"
                                                                            value={selectedReqBy}
                                                                            defaultValue={null}
                                                                            name="Q0020"
                                                                            options={reqList}
                                                                            onChange={(selectedOption) => {
                                                                                setSelectedReqBy(selectedOption);
                                                                                handleInputChange({
                                                                                    target: {
                                                                                        name: "Q0020",
                                                                                        value: selectedOption ? selectedOption.value : ""
                                                                                    }
                                                                                });
                                                                            }}
                                                                        />
                                                                        {errors.Q0020 && <p style={{color:"Red"}}>{errors.Q0020}</p>}
                                                                    </Grid>}</>:
                                                                    <Grid size={{md:5.5,sm:5.8, xs:12}} container flexDirection="column">
                                                                        <span>Requested by<small className='red_starimpo'>*</small></span>
                                                                        <input value={formData.Q0020 || ""} name='Q0020' disabled/>
                                                                        {errors.Q0020 && <p style={{color:"Red"}}>{errors.Q0020}</p>}
                                                                    </Grid>
                                                                }
                                                                {(formData.Q0010 === "No" && allData.is_external !== false) ? 
                                                                    <Grid size={{md:5.5,sm:5.8, xs:12}} container flexDirection="column">
                                                                        <span>Requested For<small className='red_starimpo'>*</small></span>
                                                                        <input value={formData.Q0030} name='Q0030' onChange={handleInputChange}
                                                                            type="text"
                                                                            maxLength="201"
                                                                        />
                                                                        {errors.Q0030 && <p style={{color:"Red"}}>{errors.Q0030}</p>}
                                                                    </Grid>
                                                                    :
                                                                    <Grid size={{md:5.5,sm:5.8, xs:12}} container flexDirection="column">
                                                                        <span>Requested For<small className='red_starimpo'>*</small></span>
                                                                        <Select
                                                                            // isDisabled={!showgroupselect || !showSubmits}
                                                                            className="basic-single select_withsearch"
                                                                            classNamePrefix="select"
                                                                            value={selectedReqFor}
                                                                            defaultValue={null}
                                                                            name="Q0030"
                                                                            options={reqList}
                                                                            onChange={(selectedOption) => {
                                                                                setSelectedReqfor(selectedOption);
                                                                                handleInputChange({
                                                                                    target: {
                                                                                        name: "Q0030",
                                                                                        value: selectedOption ? selectedOption.value : ""
                                                                                    }
                                                                                });
                                                                            }}
                                                                        />
                                                                        {errors.Q0030 && <p style={{color:"Red"}}>{errors.Q0030}</p>}
                                                                    </Grid>
                                                                }
                                                                    <Grid size={{md:5.5,sm:5.8, xs:12}} container flexDirection="column">
                                                                        <span>Impact<span style={{color:"red"}}> *</span></span>
                                                                        <select value={formData.Q0040} name='Q0040' onChange={handleInputChange} >
                                                                            <option value="">Select</option>
                                                                            <option value="P1">Enterprise wide</option>
                                                                            <option value="P2">Mutliple users</option>
                                                                            <option value="P3">Single user</option>
                                                                        </select>
                                                                        {errors.Q0040 && <p style={{color:"Red"}}>{errors.Q0040}</p>}
                                                                    </Grid>
                                                                    <Grid size={{md:5.5,sm:5.8, xs:12}} container flexDirection="column">
                                                                        <span>Location</span>
                                                                        <div className='col-12 px-0' style={{position:"relative"}}>
                                                                            <input type='text' placeholder='City and State'
                                                                                value={formData.Q0050}
                                                                                onChange={handleInputSuggChange}
                                                                                onKeyDown={handleKeyDown}
                                                                                onBlur={() => setTimeout(() => setShowSuggestions(false), 200)}
                                                                                onFocus={() => setShowSuggestions(true)}
                                                                            />
                                                                            {showSuggestions && (
                                                                                <ul className="suggestions-dropdown">
                                                                                    {filteredSuggestions.length > 0 ? (
                                                                                        filteredSuggestions.map((suggestion, index) => (
                                                                                            <li
                                                                                                key={index}
                                                                                                className={index === activeIndex ? "active" : ""}
                                                                                                onMouseDown={() => handleSuggestionClick(suggestion.label)}
                                                                                            >
                                                                                                {suggestion.label}
                                                                                            </li>
                                                                                        ))
                                                                                    ) : (
                                                                                        <li className="no-suggestions">No results found</li>
                                                                                    )}
                                                                                </ul>
                                                                            )}
                                                                        </div>
                                                                        {errors.Q0050 && <p style={{color:"Red"}}>{errors.Q0050}</p>}
                                                                    </Grid>
                                                                    <Grid size={{md:5.5,sm:5.8, xs:12}} container flexDirection="column">
                                                                        <span>Ownership Group<span style={{color:"red"}}> *</span></span>
                                                                        <Select
                                                                            isClearable
                                                                            className="basic-single select_withsearch"
                                                                            classNamePrefix="select"
                                                                            value={selectedOwnGroup}
                                                                            defaultValue={null}
                                                                            name="Q0060"
                                                                            options={ownerGroupList}
                                                                            onChange={(selectedOption) => {
                                                                                setSelectedOwnerGroup(selectedOption);
                                                                                setSelectedSolutions(null);
                                                                                setSelectedCaseType(null);
                                                                                setSelectedCaseSubType(null);
                                                                                
                                                                                setErrors((prevErrors) => ({
                                                                                    ...prevErrors,
                                                                                    Q0060: '',
                                                                                }));
                                                                                
                                                                                setFormData((prevFormData) => ({
                                                                                    ...prevFormData,
                                                                                    Q0060: selectedOption ? selectedOption.value : "",
                                                                                    Q0080: "",
                                                                                    Q0090: "",
                                                                                    Q0100: ""
                                                                                }));
                                                                            }}
                                                                        />
                                                                        {errors.Q0060 && <p style={{color:"Red"}}>{errors.Q0060}</p>}
                                                                    </Grid>
                                                                    <Grid size={{md:5.5,sm:5.8, xs:12}} container flexDirection="column">
                                                                        <span>Business Entity<span style={{color:"red"}}> *</span></span>
                                                                        <Select
                                                                            // isDisabled={!showgroupselect || !showSubmits}
                                                                            className="basic-single select_withsearch"
                                                                            classNamePrefix="select"
                                                                            value={selectedBussEntry}
                                                                            defaultValue={null}
                                                                            name="Q0070"
                                                                            options={bussEntryList}
                                                                            onChange={(selectedOption) => {
                                                                                setSelectedBussEntry(selectedOption);
                                                                                handleInputChange({
                                                                                    target: {
                                                                                        name: "Q0070",
                                                                                        value: selectedOption ? selectedOption.value : ""
                                                                                    }
                                                                                });
                                                                            }}
                                                                        />
                                                                        {errors.Q0070 && <p style={{color:"Red"}}>{errors.Q0070}</p>}
                                                                    </Grid>
                                                                    {selectedOwnGroup &&
                                                                    <Grid size={{md:5.5,sm:5.8, xs:12}} container flexDirection="column">
                                                                        <span>Solution<span style={{color:"red"}}> *</span></span>
                                                                        <Select
                                                                            // isDisabled={!showgroupselect || !showSubmits}
                                                                            className="basic-single select_withsearch"
                                                                            classNamePrefix="select"
                                                                            value={selectedSolutions}
                                                                            defaultValue={null}
                                                                            name="Q0080"
                                                                            options={solutionsList}
                                                                            onChange={(selectedOption) => {
                                                                                setSelectedSolutions(selectedOption);
                                                                                setSelectedCaseType(null);
                                                                                setSelectedCaseSubType(null);
                                                                                
                                                                                setErrors((prevErrors) => ({
                                                                                    ...prevErrors,
                                                                                    Q0080: '',
                                                                                }));
                                                                                
                                                                                setFormData((prevFormData) => ({
                                                                                    ...prevFormData,
                                                                                    Q0080: selectedOption ? selectedOption.value : "",
                                                                                    Q0090: "",
                                                                                    Q0100: ""
                                                                                }));
                                                                            }}
                                                                        />
                                                                        {errors.Q0080 && <p style={{color:"Red"}}>{errors.Q0080}</p>}
                                                                    </Grid>}
                                                                    {selectedSolutions &&
                                                                    <Grid size={{md:5.5,sm:5.8, xs:12}} container flexDirection="column">
                                                                        <span>Case Type<span style={{color:"red"}}> *</span></span>
                                                                        <Select
                                                                            // isDisabled={!showgroupselect || !showSubmits}
                                                                            className="basic-single select_withsearch"
                                                                            classNamePrefix="select"
                                                                            value={selectedCaseType}
                                                                            defaultValue={null}
                                                                            name="Q0090"
                                                                            options={caseTypeList}
                                                                            onChange={(selectedOption) => {
                                                                                setSelectedCaseType(selectedOption);
                                                                                setSelectedCaseSubType(null);
                                                                                
                                                                                setErrors((prevErrors) => ({
                                                                                    ...prevErrors,
                                                                                    Q0090: '',
                                                                                }));
                                                                                
                                                                                setFormData((prevFormData) => ({
                                                                                    ...prevFormData,
                                                                                    Q0090: selectedOption ? selectedOption.value : "",
                                                                                    Q0100: ""
                                                                                }));
                                                                            }}
                                                                        />
                                                                        {errors.Q0090 && <p style={{color:"Red"}}>{errors.Q0090}</p>}
                                                                    </Grid>}
                                                                    {selectedCaseType &&
                                                                    <Grid size={{md:5.5,sm:5.8, xs:12}} container flexDirection="column">
                                                                        <span>Case Sub Type<span style={{color:"red"}}> *</span></span>
                                                                        <Select
                                                                            // isDisabled={!showgroupselect || !showSubmits}
                                                                            className="basic-single select_withsearch"
                                                                            classNamePrefix="select"
                                                                            value={selectedCaseSubType}
                                                                            defaultValue={null}
                                                                            name="Q0100"
                                                                            options={caseSubTypeList}
                                                                            onChange={(selectedOption) => {
                                                                                setSelectedCaseSubType(selectedOption);
                                                                                handleInputChange({
                                                                                    target: {
                                                                                        name: "Q0100",
                                                                                        value: selectedOption ? selectedOption.value : ""
                                                                                    }
                                                                                });
                                                                            }}
                                                                        />
                                                                        {errors.Q0100 && <p style={{color:"Red"}}>{errors.Q0100}</p>}
                                                                    </Grid>}
                                                                    <Grid size={{md:5.5, sm:5.8, xs:12}} container flexDirection="column">
                                                                        <span>Re-assignment Count <span style={{color:"red"}}> *</span></span>
                                                                        <input value={allData?.case?.reassignment_count} disabled/>
                                                                    </Grid>
                                                                    <Grid size={{xs:12}} container flexDirection="column">
                                                                        <span>Attachments</span>
                                                                        <Grid size={{xs: 12 }} container justifyContent="space-between">
                                                                            <div
                                                                                onDrop={handleDrop}
                                                                                onDragOver={handleDragOver}
                                                                                className='drag_uploaders align-items-center flex-column d-flex'
                                                                            >
                                                                                <FontAwesomeIcon className='file_uploadericon' icon={faFileLines} />
                                                                                <input
                                                                                    type="file"
                                                                                    multiple
                                                                                    onChange={handleFileChange}
                                                                                    style={{ display: 'none' }}
                                                                                    id="file-upload"
                                                                                    ref={fileInputRef} // Attach the ref here
                                                                                />
                                                                                <label htmlFor="file-upload">
                                                                                    Browse Files
                                                                                </label>
                                                                                <p className='w-100 mb-0 mt-3'>or drop file here</p>
                                                                            </div>
                                                                            {errors.Q0120 && <div style={{ color: 'red', margin: '10px 0px' }}>{errors.Q0120}</div>}
                                                                        </Grid>
                                                                        <Grid size={{xs:12}} container justifyContent="space-between" className="mt-4">
                                                                            {files.map((file, index) => (
                                                                                <Grid key={index} size={{xs:12}} container justifyContent="space-between" alignItems="center" className="tablelisterattach reportincident">
                                                                                    <Grid container className="pinkbgattachreport" alignItems="center">
                                                                                        <span className='spanreport_elipse' style={{whiteSpace: "nowrap"}}>{index + 1}<span className='filenamesshow ms-3'>{file.name || file}</span></span>
                                                                                        <button onClick={(e) => handleRemoveFile(index)}>
                                                                                            <FontAwesomeIcon icon={faXmark} />
                                                                                        </button>
                                                                                        {isLink(file) && (
                                                                                            <Link className='d-flex' to={`${file}`} target='_blank'>
                                                                                                <FontAwesomeIcon style={{fontSize:"medium"}} icon={faEye} />
                                                                                            </Link>
                                                                                        )}
                                                                                    </Grid>
                                                                                </Grid>
                                                                            ))}
                                                                        </Grid>
                                                                    </Grid>
                                                                    {errorMessage && <div style={{ color: 'red', margin: '10px 0px' }}>{errorMessage}</div>}
                                                                    {allDataSubmit?.can_submit === true &&
                                                                    <Grid size={{sm:12, xs:12}} container className="mt-2 consplit_btns gap-3">
                                                                        <button type="button" className='registersendbtn1' onClick={()=>navigate('/task/my-task')}>Cancel</button>
                                                                        <button type="button" className='registersendbtn2' onClick={handleSubmit}>{submitloader ? <img src={require('../../../../assets/whiteloader.gif')} alt=''/> : 'Submit'}</button>
                                                                    </Grid>}
                                                                </Grid>
                                                            </div>
                                                        </Grid>:
                                                        <Grid size={{sm:12}} container alignItems="center">
                                                            <Grid size={{lg:12,xs:12}} container justifyContent="space-between" className="regiter_inputs i94validateinput">
                                                                {allData && allData.is_external === true &&
                                                                <Grid size={{xs:12}} container flexDirection="column">
                                                                    <span>Is the requester a BenchTrack user?</span>
                                                                    <p>{refetchData?.Q0010?.display_value}</p>
                                                                </Grid>}
                                                                <Grid size={{md:5.5,sm:5.8, xs:12}} container flexDirection="column">
                                                                    <span>Requested By</span>
                                                                    <p>{allData?.case?.requested_by_name || "No Data"}</p>
                                                                </Grid>
                                                                <Grid size={{md:5.5,sm:5.8, xs:12}} container flexDirection="column">
                                                                    <span>Requested For</span>
                                                                    <p>{allData?.case?.requested_for_name || "No Data"}</p>
                                                                </Grid>
                                                                <Grid size={{md:5.5,sm:5.8, xs:12}} container flexDirection="column">
                                                                    <span>Impact</span>
                                                                    <p>{refetchData?.Q0040?.display_value}</p>
                                                                </Grid>
                                                                {refetchData?.Q0050?.display_value && 
                                                                <Grid size={{md:5.5,sm:5.8, xs:12}} container flexDirection="column">
                                                                    <span>Location</span>
                                                                    <p>{refetchData?.Q0050?.display_value}</p>
                                                                </Grid>}
                                                                <Grid size={{md:5.5,sm:5.8, xs:12}} container flexDirection="column">
                                                                    <span>Ownership Group</span>
                                                                    <p>{refetchData?.Q0060?.display_value}</p>
                                                                </Grid>
                                                                <Grid size={{md:5.5,sm:5.8, xs:12}} container flexDirection="column">
                                                                    <span>Business Entity</span>
                                                                    <p>{refetchData?.Q0070?.display_value}</p>
                                                                </Grid>
                                                                <Grid size={{md:5.5,sm:5.8, xs:12}} container flexDirection="column">
                                                                    <span>Solution</span>
                                                                    <p>{refetchData?.Q0080?.display_value}</p>
                                                                </Grid>
                                                                <Grid size={{md:5.5,sm:5.8, xs:12}} container flexDirection="column">
                                                                    <span>Case Type</span>
                                                                    <p>{refetchData?.Q0090?.display_value}</p>
                                                                </Grid>
                                                                <Grid size={{md:5.5,sm:5.8, xs:12}} container flexDirection="column">
                                                                    <span>Case Sub Type</span>
                                                                    <p>{refetchData?.Q0100?.display_value}</p>
                                                                </Grid>
                                                                <Grid size={{md:5.5, sm:5.8, xs:12}} container flexDirection="column">
                                                                    <span>Re-assignment Count</span>
                                                                    <p> {allData?.case?.reassignment_count} </p>
                                                                </Grid>
                                                                {refetchData?.Q0120?.display_value?.length > 0 &&
                                                                <Grid size={{xs:12}} container flexDirection="column">
                                                                    <span>Attachments</span>
                                                                    <Grid size={{xs:12}} container justifyContent="space-between">
                                                                        {refetchData?.Q0120?.display_value.map((file, index) => (
                                                                            <span className='mt-2' key={index}>{index +1}. <Link to={`${file}`} target='_blank'>View</Link></span>
                                                                        ))}
                                                                    </Grid>
                                                                </Grid>}
                                                            </Grid>
                                                        </Grid>}
                                                    </Tab>
                                                    <Tab eventKey="assignment" title="Assignments">
                                                        {activeTab === "assignment" && <AssignmentsGeneralCase />}
                                                    </Tab>
                                                    {/* <Tab eventKey="discussions" title="Discussions">
                                                        {activeTab === "discussions" && <GeneralCaseDisccuss />}
                                                    </Tab> */}
                                                    <Tab eventKey="knowledge" title="Knowledge">
                                                        {activeTab === "knowledge" && <GeneralCaseKnowledge />}
                                                    </Tab>
                                                    <Tab eventKey="history" title="History" style={{ flexGrow: 1 }}>
                                                        {activeTab === "history" && <GeneralCaseHistory />}
                                                    </Tab>
                                                </Tabs>
                                            </Grid>
                                        </Grid>
                                    </Tab>
                                    {showCase && 
                                    <Tab eventKey="case" title="Case">
                                        {activeTabCase === "case" && <CaseAllDetails expanded={expanded}/>}
                                    </Tab>
                                    }
                                </Tabs>
                            </Grid>
                            <Grid alignContent="flex-start" size={{ lg: expanded ? 4.4 : 0.5, md: expanded ? 4.8 : 0.4, xs: 12, }} container className="border-start ps-3" sx={{ transition: "all 0.35s cubic-bezier(0.4,0,0.2,1)", overflow: "hidden", minWidth: expanded ? undefined : 0, }}>
                                <button onClick={() => setExpanded((prev) => !prev)} className='main_expanddisbtn'>
                                    {expanded ? <FontAwesomeIcon icon={faChevronRight} /> : <FontAwesomeIcon icon={faChevronLeft} />}
                                </button>
                                <Grid size={{xs:12}} container className={ expanded ? "" : "d-none"}>
                                    <DiscussTaskCase showCase={showCase} casediscuss={allData?.case?.is_requester}/>
                                </Grid>
                            </Grid>
                    </Grid>}
                </Grid>
                <Modal
                    show={showSuccess} 
                    onHide={handleCloseSuccess}
                    size="md"
                    aria-labelledby="contained-modal-title-vcenter"
                    centered
                    >
                    <Modal.Header closeButton style={{border:"none"}}>
                        
                    </Modal.Header>
                    <Modal.Body>
                        <div className='d-flex w-100 text-center flex-column align-items-center modal_register'>
                            <FontAwesomeIcon className='main_tickiconpopup' icon={faCircleCheck} />
                            <h3>Successfully!</h3>
                            <small>Helpdesk Review updated successfully.</small>
                            <button onClick={handleCloseSuccess}>OK</button>
                        </div>
                    </Modal.Body>
                </Modal>
            </div>
        </div>
    </div>
  )
}

export default Triage
